import { __makeTemplateObject, __assign, __rest } from 'tslib';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { typography } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';

var StyledHeading = /*#__PURE__*/styled("h2").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Heading__StyledHeading",
  componentId: "sc-1rzikiz-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  ", ";\n"], ["\n  margin-top: 0;\n  margin-bottom: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  ", ";\n"])), typography);
var defaultStyles = {
  letterSpacing: "tight",
  lineHeight: "none",
  color: "text.heading",
  fontFamily: "heading"
};
var headingVariants = {
  xxl: __assign(__assign({}, defaultStyles), {
    fontSize: [12, 13, 14]
  }),
  xl: __assign(__assign({}, defaultStyles), {
    fontSize: [9, 11, 13]
  }),
  lg: __assign(__assign({}, defaultStyles), {
    fontSize: [7, 10, 12]
  }),
  md: __assign(__assign({}, defaultStyles), {
    fontSize: [5, 8, 10]
  }),
  sm: __assign(__assign({}, defaultStyles), {
    fontSize: [4, 5, 7]
  }),
  xs: __assign(__assign({}, defaultStyles), {
    fontSize: [3, 4, 5]
  }),
  xxs: __assign(__assign({}, defaultStyles), {
    fontSize: [1, 2, 3]
  })
};
var Heading = forwardRef(function (_a, ref) {
  var variant = _a.variant,
    rest = __rest(_a, ["variant"]);
  var styles = headingVariants[variant];
  return React__default.createElement(StyledHeading, __assign({
    ref: ref
  }, styles, rest));
});
Heading.defaultProps = {
  variant: "md"
};
Heading.displayName = "Heading";
var templateObject_1;

export { Heading, StyledHeading, headingVariants };
//# sourceMappingURL=Heading.js.map
